import { DependencyList, useEffect } from "react";

export const useAsyncEffect = (effect: (isActive: () => boolean) => Promise<void>, deps: DependencyList = []) => {
    useEffect(() => {
        let active = true;
        effect(() => active);
        return () => { active = false; };
    }, deps);
};
